import { lms_v2_api,lms_login_service_api  } from './login-config.js';

async function getCompanyDetails(domainName) {
    try {
        const response = await lms_v2_api.post('/lmsAuth/checkDomainExits/', {
            domainName,
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

async function userTokenAuthentication(token) {

    try {

        const response = await lms_v2_api.post('/lmsAuth/lmsToken/', {
            authToken: token
        });
        return response.data;

    } catch (error) {
        throw error;
    }
}

async function userLogin(loginObj) {
    try {
        const response = await lms_login_service_api.post('/login',loginObj);
        return response;
    } catch (error) {
        throw error;
    }
}

async function fetch_otp_login_details(forgotPassObj) {
    try {
        const response = await lms_login_service_api.post('/serv_fetch_otp_login_details',forgotPassObj);
        return response;
    } catch (error) {
        throw error;
    }
}

async function send_otp_for_logins(forgotObj) {
    try {
        const response = await lms_login_service_api.post('/serv_send_otp_for_login',forgotObj);
        return response;
    } catch (error) {
        throw error;
    }
}

async function verifyOtp(userObj) {
    try {
        const response = await lms_login_service_api.post('/otp_validation_for_login',userObj);
        return response;
    } catch (error) {
        throw error;
    }
}

async function verifyGoogleAuth(userObj) {
    try {
        const response = await lms_login_service_api.post('/login_with_google_in_lms',userObj);
        return response;
    } catch (error) {
        throw error;
    }
}

async function get_profile_details(profileObj) {
    try {
        const response = await lms_login_service_api.post('/company_setup/loadUserProfile',profileObj);
        return response;
    } catch (error) {
        throw error;
    }
}

async function activateUserAccount(userObj) {
    try {
        const response = await lms_login_service_api.post('/company_setup/activeUserAccount',userObj);
        return response;
    } catch (error) {
        throw error;
    }
}



export { getCompanyDetails, userLogin,fetch_otp_login_details,send_otp_for_logins, userTokenAuthentication , verifyOtp,verifyGoogleAuth, get_profile_details, activateUserAccount};
